/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import React from 'react';
import { compose } from 'redux';
import { object } from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import ProductInstructions from './ProductInstructions';

const styles = (theme) => {
    const { palette, breakpoints: { maxWidth } } = theme;
    return {
        productInstructionsWrapper: {
            '&.productInstructionsContainer': {
                borderBottom: `2px solid ${palette.common.black}`,
                marginBottom: '40px',
                [theme.breakpoints.down(maxWidth.small_screen_up)]: {
                    paddingBottom: '20px',
                },
                '& .instructionsTitle': {
                    fontWeight: '700',
                    color: palette.common.black,
                    textTransform: 'uppercase',
                    borderBottom: `2px solid ${palette.common.black}`,
                    fontSize: '1rem',
                },
                '& div': {
                    '&:first-child': {
                        marginBottom: '0px!important',
                    },
                },
            },
        },
    };
};

const PlantsCareDetails = (props) => {
    const { classes, pageData } = props;
    return (
        <div className={`${classes.productInstructionsWrapper} productInstructionsContainer product-details`}>
            <div className="instructionsTitle" role="heading" aria-level="2">Plant Care</div>
            <ProductInstructions pageData={pageData} />
        </div>
    );
};

PlantsCareDetails.propTypes = {
    classes: object.isRequired,
    pageData: object.isRequired,
};

export default compose(withStyles(styles))(PlantsCareDetails);
